import * as Actions from '../actions';

const initialState = {
    qualificationList: [],
    isQualificationLoaded: false,
    currentQualification: {
        qualification_id: 0,
        QualificationName: '',
        QualificationDescription: '',
        QualificationText: '',
        company_id: 0,
        RequireAsset: 0,
        CreateAuthID: 0,
        LastEditAuthID: 0,
        CreationDate: '',
        LastEditDate: ''
    },
    editInfo: {
        CreateAuthEmail: 0,
        LastEditAuthEmail: 0,
        CreationDate: '',
        LastEditDate: ''
    }
}

const qualificationReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_QUALIFICATION_LOADED):
            {
                return {
                    ...state,
                    isQualificationLoaded: action.payload
                }
            }
        case (Actions.UPDATE_QUALIFICATION_FORM):
            {
                return {
                    ...state,
                    currentQualification: { ...state.currentQualification, ...action.payload }
                }
            }
        case (Actions.GET_QUALIFICATION):
            {
                return {
                    ...state,
                    currentQualification: { ...initialState.currentQualification, ...action.payload.header }
                };
            }
        case (Actions.GET_QUALIFICATION_LIST):
            {
                return {
                    ...state,
                    qualificationList: action.payload
                }
            }
        case (Actions.GET_QUALIFICATION_EDIT_INFO):
            {
                return {
                    ...state,
                    editInfo: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
}

export default qualificationReducer;


// WEBPACK FOOTER //
// src/main/content/qualification/store/reducers/qualification.reducer.js